<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/18PlTHn/tc-custom/9781035841356.jpg?1718106147961" alt="This image is the cover for the book The Price of Love"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">The Price of Love
      </h1>
      <p class="bookDescription body article font2">
        <p>The Price of Love unfolds across a century, tracing the enduring bonds of love and friendship amid the changing tides of time. Rooted in a quaint Kent village, the narrative unfurls around Dolly and Polly, two inseparable souls nurtured amidst rustic simplicity. Their youthful days transition into service at the local Manor House, under the genteel watch of Sir Charles, Lady Frances, and the stern yet nurturing Housekeeper, Jenny Armstrong. Yet, as the winds of the Great War sweep across their lives, an era of innocence ends, replaced by an epoch of growth amid trials. As the war’s tempest recedes, life’s inexorable stream carries them through a kaleidoscope of emotions, intertwining joy, and sorrow in a delicate dance. Through every hardship, the steadfast friendship of Dolly and Polly remains their beacon, each a pillar of strength for the other. Polly becomes a cornerstone of support for her daughter Elizabeth, helping her navigate the turbulent waters of a troubled marriage to Robert. Simultaneously, Dolly navigates through profound loss, her resilience leading her towards rebirth and healing. The Price of Love is a tender homage to the unwavering spirit of friendship and the remarkable resilience of love amid life’s inexorable ebbs and flows. Through Dolly and Polly’s journey, readers will find a poignant exploration of love’s enduring power to heal, to uplift, and to bind hearts together through a century of unyielding change.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Jackie McIntosh
      </h2>
      
      <p class="authorDescription body article">Jackie is happily retired living in Sussex with her husband, Bill. She worked in sales and in retail for a number of years and had always enjoyed writing but never ‘had the time’. Lockdown changed all that. They have two children and five grandchildren, their son is in Sussex and their daughter is in Derby, and they enjoy spending time in both these wonderful counties.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Austin Macauley Publishers
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?5115636e